<div class="errorPage-container d-flex flex-column">
    <div class="error-page d-flex">
        <img class="error-page-image" alt="Page not found" src="/assets/images/error-pages/error-server-error.svg"/>
        <div class="error-page-content">
            <h1 translate="SERVER_ERROR_TITLE"></h1>
            <p>
                {{
                    sessionExpired
                        ? ('SERVER_ERROR_REQUEST_ID_EXPIRED_TEXT' | translate)
                        : ('SERVER_ERROR_TEXT' | translate: {value: requestId})
                }}
            </p>
            @if (!sessionExpired) {
                <p>
                    {{ errorService.lastError.message }}
                </p>
            }
            @if (retriesExceeded) {
                <p>
                    {{ 'TOO_MANY_ERRORS' | translate }}
                </p>
            }
        </div>
    </div>
    @if (!retriesExceeded) {
        <div class="d-flex w-100 justify-content-center">
            <button class="btn btn-primary m-3" translate="RETURN_TO_PREVIOUS_STEP" (click)="retry()"></button>
            <button class="btn btn-secondary m-3" translate="RETURN_TO_EMPLOYEE_STEP"
                    (click)="returnToStepOne()"></button>
        </div>
    }
</div>
